export enum TransactionRole {
  Lender = 'lender',
  Borrower = 'borrower'
}
